"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useWindowDimensions = function useWindowDimensions() {
  var getWindowDimensions = (0, _react.useCallback)(function () {
    if (typeof window !== 'undefined') {
      return {
        width: window.innerWidth,
        height: window.innerHeight
      };
    }

    return {
      width: 0,
      height: 0
    };
  }, []);

  var _useState = (0, _react.useState)(getWindowDimensions),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      windowDimensions = _useState2[0],
      setWindowDimensions = _useState2[1];

  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      var listener = function listener() {
        return setWindowDimensions(getWindowDimensions());
      };

      window.addEventListener('resize', listener);
      return function () {
        return window.removeEventListener('resize', listener);
      };
    }
  }, [getWindowDimensions]);
  return windowDimensions;
};

__signature__(useWindowDimensions, "useCallback{getWindowDimensions}\nuseState{[windowDimensions, setWindowDimensions](getWindowDimensions)}\nuseEffect{}");

var _default = useWindowDimensions;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useWindowDimensions, "useWindowDimensions", "/builds/bA1zbJom/0/gojob/ui-bits/src/hooks/useWindowDimensions.ts");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/hooks/useWindowDimensions.ts");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();